export default __webpack_public_path__ + "static/media/triangle-pointer-moonchicken.32eb4443.svg";